import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { Clock, DollarSign, Lock, Link } from 'lucide-react';
export function AsicProblemSlide() {
  const problems = [{
    icon: Clock,
    title: '18–36 Month Design Cycles',
    desc: "Can't adapt mid-development to architectural shifts — MoE, sparse attention, new tokenizers all emerged faster than a single tape-out cycle."
  }, {
    icon: DollarSign,
    title: '$50M–$200M NRE',
    desc: 'Viable only at hyperscale volume. Prohibitive for startups, research labs, and specialized workloads that need custom inference.'
  }, {
    icon: Lock,
    title: 'Fixed at Tape-Out',
    desc: 'Optimizations locked in at fabrication. Limited recourse if model requirements evolve — context length, precision, sparsity patterns all become immutable.'
  }, {
    icon: Link,
    title: 'Toolchain Lock-In',
    desc: 'Proprietary compilers and frameworks reduce portability. Moving workloads between ASIC vendors means rewriting the entire software stack.'
  }];
  return <SlideLayout slideNumber={7} totalSlides={20} title="The ASIC Trade-off" data-id="element-32">
      <div className="w-full h-full flex flex-col" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-5" data-id="element-34">
          <h2 className="text-4xl md:text-5xl font-bold mb-2" data-id="element-35">
            The ASIC Trade-off
          </h2>
          <p className="text-2xl text-brand-muted" data-id="element-36">
            Performance vs. Flexibility & Capital Risk
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 flex-1" data-id="element-37">
          {problems.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1 + 0.2
        }} className="bg-brand-surface border border-red-900/40 rounded-2xl p-6 flex items-start gap-5 relative overflow-hidden" data-id="element-38">
              <div className="absolute top-0 left-0 w-1 h-full bg-red-500/40 rounded-l-2xl" data-id="element-39" />
              <div className="shrink-0 p-3 bg-red-500/10 rounded-xl text-red-400" data-id="element-40">
                <item.icon size={36} data-id="element-41" />
              </div>
              <div data-id="element-42">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-43">
                  {item.title}
                </h3>
                <p className="text-xl text-brand-muted leading-relaxed" data-id="element-44">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </SlideLayout>;
}